<template>
	<div id="single-image-carousel-wrapper" itemscope itemtype="https://schema.org/Thing">
		<div data-slide-id="zoom" class="zoom-gallery-slide" :class="{ active: activeSlide === 'zoom', 'abtest-curtain': showCurtain  }">
			<button :title="$translate('Eros::Template.imageCarouselPrev')" class="MagicToolboxSlides-arrow magic-prev" @click="mzGoTo('prev')"></button>
			<button :title="$translate('Eros::Template.imageCarouselNext')" class="MagicToolboxSlides-arrow magic-next" @click="mzGoTo('next')"></button>
			<a
				ref="single"
				id="single-carousel-new"
				class="prop-1-1 MagicZoom"
				:class="{ 'mz-ready': magicZoomStatus }"
				:title="getItemName()"
				:href="convertFormat(getAssetParams(fullImages[0].url, 'full'))"
				:key="currentVariation.variation.id"
				:rel="setNoFollow ? 'nofollow' : null"
				:aria-label="$translate('Eros::Template.mzZoomShowFull')"
			>
				<img
					:src="convertFormat(getAssetParams(singleImages[0].url, 'main'))"
					:alt="getAltText(singleImages[0])"
					:title="getAltText(singleImages[0])"
					itemprop="image"
					:fetchpriority="highFetchpriority ? 'high' : null"
				/>
			</a>
		</div>
		<div
			v-for="(video, index) in carouselVideos"
			:key="index"
			:data-slide-id="'video-' + video.position"
			class="zoom-gallery-slide video-slide"
			:class="{ active: activeSlide === 'video-' + video.position }"
		>
			<button :title="$translate('Eros::Template.imageCarouselPrev')" class="MagicToolboxSlides-arrow magic-prev" @click="mzGoTo('prev')"></button>
			<button :title="$translate('Eros::Template.imageCarouselNext')" class="MagicToolboxSlides-arrow magic-next" @click="mzGoTo('next')"></button>
			<iframe width="400" height="225" :src="video.url" frameborder="0" allowfullscreen></iframe>
		</div>
		<div id="thumb-dots" ref="dots">
			<div v-for="(imagePreview, index) in carouselImages" :key="index" :data-dot-id="index" :class="{ 'thumb-dot-selected': index === currentItem }"></div>
		</div>
		<div
			id="thumb-carousel-new"
			ref="thumbs"
			class="selectors owl-thumbs owl-carousel owl-theme owl-single-item"
			:key="'thumb-' + currentVariation.variation.id"
		>
			<div v-for="(imagePreview, index) in carouselImages" :key="index" class="prop-1-1">
				<template v-if="Object.keys(imagePreview).includes('url') && imagePreview.url.includes('youtube')">
					<a class="image-container"
						@click="goTo(index, 'video-' + imagePreview.position)"
						href="#"
						:rel="setNoFollow ? 'nofollow' : null"
					>
						<img
							class="owl-thumb border-appearance"
							:class="{ active: currentItem === index }"
							:src="imagePreview.thumbUrl"
							alt="YouTube-Video"
							title="YouTube-Video"
						/>
					</a>
				</template>
				<template v-else>
					<a
						@click="goTo(index)"
						class="image-container"
						data-zoom-id="single-carousel-new"
						:href="convertFormat(getAssetParams(fullImages[index].url, 'full'))"
						:data-image="convertFormat(getAssetParams(fullImages[index].url, 'full'))"
						:data-index="index"
						:rel="setNoFollow ? 'nofollow' : null"
					>
						<lazy-img
							:alt="getAltText(imagePreview)"
							:image-url="getAssetParams(imagePreview.url, 'thumbs')"
							:title="getAltText(imagePreview)"
							:width="getImageWidth(imagePreview)"
                        	:height="getImageHeight(imagePreview)"
							picture-class="owl-thumb border-appearance"
							:class="{ active: currentItem === index }" />
					</a>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { detectWebP } from "../../../ceres/helper/featureDetect";
import { isDefined } from "../../../ceres/helper/utils";
import { whenConsented } from "../../helper/whenConsented";
import { ImageConverterMixin } from "../../mixins/imageConverter";

function getDirection(prevIndex, newIndex, lastIndex, revert = false) {
	if (isNaN(prevIndex)) return "none";

	let direction = "next";
	
	if (newIndex < prevIndex || prevIndex === 0 && newIndex === lastIndex) {
		if (newIndex === 0) {
			if (prevIndex !== lastIndex) {
				direction = "prev";
			}
		} else {
			direction = "prev";
		}
	}

	return revert ? (direction === "next" ? "prev" : "next") : direction;
}
function handleDefaultMzUpdate(newIndex) {
	if ($("#thumb-carousel-new .owl-thumb.active").length > 0) {
		$("#thumb-carousel-new .owl-thumb.active").first().removeClass("active");
	}
	if ($("#thumb-carousel-new .mz-thumb-selected .owl-thumb").length > 0) {
		$("#thumb-carousel-new .mz-thumb-selected .owl-thumb").first().addClass("active");
	}
	$("#thumb-carousel-new").trigger("to.owl.carousel", [newIndex, 350]);
}

export default {
    name: "item-image-carousel",

	mixins: [ImageConverterMixin],

	props: {
		maxQuantity: {
			type: Number,
			default: 10
		},
		imageUrlAccessor: {
			type: String,
			default: "url"
		},
		showThumbs: {
			type: Boolean,
			default: true
		},
		showDots: {
			type: Boolean,
			default: true
		},
		animationStyle: {
			type: String,
			default: "standard"
		},
		pluginPath: {
			type: String,
			default: ""
		},
		overwriteUrl: {
			type: String,
			default: ""
		},
		imageOptions: {
			type: Object,
			default() {
				return {};
			}
		},
		setNoFollow: {
			type: Boolean,
			default: false
		},
		waitForConsent: {
			type: Boolean,
			default: true
		},
		highFetchpriority: {
			type: Boolean,
			default: true
		}
	},

	inject: {
		itemId: {
			default: null
		}
	},

	data() {
		return {
			currentItem: 0,
			supported: undefined,
			activeSlide: "zoom",
			videoCount: 0,
			expandOpened: false,
			suppressUpdate: 0,
			isVideoSlide: false,
			isClickEvent: false,
			skipDirection: "none",
			showCurtain: false,
		};
	},

	computed: {
		currentVariation() {
			return this.$store.getters[`${this.itemId}/currentItemVariation`];
		},
		carouselImages() {
			return this.addVideo(
				this.$options.filters.itemImages(this.currentVariation.images, "urlPreview").slice(0, this.maxQuantity)
			);
		},
		fullImages() {
			return this.addVideo(
				this.$options.filters.itemImages(this.currentVariation.images, "url").slice(0, this.maxQuantity)
			);
		},
		singleImages() {
			return this.addVideo(
				this.$options.filters
					.itemImages(this.currentVariation.images, this.imageUrlAccessor)
					.slice(0, this.maxQuantity)
			);
		},
		carouselVideos() {
			return this.carouselImages.filter((entry) => Object.keys(entry).includes("url") && entry.url.includes("youtube"));
		},
		magicZoomStatus() {
			return this.$store.getters[`${this.itemId}/magicZoomStatus`];
		},
		isSSR() {
			return App.isSSR ?? false;
		}
	},

	watch: {
		currentVariation: {
			handler(val, oldVal) {
				if (val !== oldVal) {
					if (this.waitForConsent) {
						whenConsented(
							"",
							() => {
								setTimeout(() => {
									this.reInitialize(true);
								}, 1);
							},
							() => {}
						);
					} else {
						setTimeout(() => {
							this.reInitialize(true);
						}, 1);
					}
				}
			},
			deep: true
		}
	},

	beforeMount() {
		detectWebP((supported) => {
			this.supported = supported;
		});
	},

	mounted() {
		if (this.waitForConsent) {
			whenConsented(
				"",
				() => {
					this.mountInit();
				},
				() => {}
			);
		} else {
			this.mountInit();
		}
	},

	methods: {
		getImageCount() {
			return this.carouselImages.length;
		},
		reInitialize(watcher = false) {
			// const $thumbs = $(this.$refs.thumbs);

			this.$store.commit(`${this.itemId}/setMagicZoomStatus`, false);

			// $thumbs.find(".mz-thumb-selected").removeClass("mz-thumb-selected");
			// $thumbs.find(".owl-thumb.active").removeClass("active");

			// $thumbs.trigger("destroy.owl.carousel");
			// $thumbs.html($thumbs.find(".owl-stage-outer").html()).removeClass("owl-loaded");
			// $thumbs.find(".owl-item").remove();

			this.initThumbCarousel();
			this.$store.commit(`${this.itemId}/setMagicZoomStatus`, true);

			// if (!watcher && App.config.log.performanceSsr && !App.isSSR) MagicZoom.start(this.$refs.single.id);
			// if (!watcher) MagicZoom.start(this.$refs.single.id);
			if (!watcher) {
				if (App.config.log.performanceSsr) {
					if (!this.isSSR) {
						setTimeout(() => {
							MagicZoom.start("single-carousel-new");
						}, 250);
					}
				} else {
					setTimeout(() => {
						MagicZoom.start("single-carousel-new");
					}, 250);
				}
			}
		},

		initThumbCarousel() {
			$(this.$refs.thumbs).owlCarousel({
				autoHeight: true,
				dots: false,
				items: 5,
				lazyLoad: true,
				loop: false,
				margin: 10,
				mouseDrag: false,
				center: false,
				nav: true,
				navClass: ["owl-single-item-nav left carousel-control", "owl-single-item-nav right carousel-control"],
				navContainerClass: "",
				navText: [
					'<i class="owl-single-item-control fa fa-chevron-left" aria-hidden="true"></i>',
					'<i class="owl-single-item-control fa fa-chevron-right" aria-hidden="true"></i>'
				],
				smartSpeed: 350
			});
		},

		goTo(index, slide = "zoom", isClickEvent = true) {
			const $thumbs = $(this.$refs.thumbs);

			this.isClickEvent = isClickEvent;
			this.activeSlide = slide;
			this.currentItem = index;
			$thumbs.trigger("to.owl.carousel", [index, 350]);
		},

		getAltText(image) {
			return (image && image.alternate) ? image.alternate : this.$options.filters.itemName(this.currentVariation);
		},

		getItemName(image) {
			return (image && image.name) ? image.name : this.$options.filters.itemName(this.currentVariation);
		},

		getImageWidth(image)
        {
          return image && image.width ? image.width : this.$options.filters.itemImageWidth(this.carouselImages);
        },

        getImageHeight(image)
        {
          return image && image.height ? image.height : this.$options.filters.itemImageHeight(this.carouselImages);
        },

		addVideo(list) {
			let videoData = [];

			if (
				this.currentVariation !== undefined &&
				Object.keys(this.currentVariation).includes("variationProperties") &&
				this.currentVariation.variationProperties.length > 0
			) {
				for (let groupIndex = 0; groupIndex < this.currentVariation.variationProperties.length; groupIndex++) {
					const variationPropertyGroup = this.currentVariation.variationProperties[groupIndex].properties;

					if (variationPropertyGroup !== undefined) {
						for (let propIndex = 0; propIndex < variationPropertyGroup.length; propIndex++) {
							const variationProperty = variationPropertyGroup[propIndex];
							const videoURLs = [];

							if (
								Object.keys(variationProperty).includes("names") && 
								Object.keys(variationProperty.names).includes("name") &&
								variationProperty.names.name.includes("YouTube")
							) {
								if (variationProperty.values.length > 1) {
									if (variationProperty.values[0].value.length) {
										videoURLs = variationProperty.values[0].value.split(",");
									}
								} else if ("value" in variationProperty.values && variationProperty.values.value.length) {
									videoURLs = variationProperty.values.value.split(",");
								} else {
									break;
								}

								for (let index = 0; index < videoURLs.length; index++) {
									let videoURL = videoURLs[index].split(";");
									const position = parseInt(videoURL.length === 2 ? videoURL[1] : 1);

									videoURL = videoURL[0].replace("youtube.com", "youtube-nocookie.com/embed");
									const watchId = videoURL.split("watch?v=")[1].split("&")[0];
									videoURL = "https://www.youtube-nocookie.com/embed/" + watchId;
									let thumbUrl = "https://img.youtube.com/vi/" + watchId + "/1.jpg";

									if (isDefined(this.supported) && this.supported) {
										thumbUrl = "https://i.ytimg.com/vi_webp/" + watchId + "/mqdefault.webp";
									}

									videoData.push({
										name: "",
										url: videoURL,
										position: position,
										alternate: "",
										thumbUrl
									});
								}
								break;
							}
						}
					}
				}

				this.videoCount = videoData.length;

				if (this.videoCount > 0) {
					for (let vidIndex = 0; vidIndex < videoData.length; vidIndex++) {
						const videoObject = videoData[vidIndex];

						list.splice(
							(videoObject.position < 0 ? list.length : 0) + videoObject.position,
							0,
							videoObject
						);
					}
				}
			}

			return list;
		},

		getAssetParams(url, type = "main") {
			let assetParams = "";
			if (this.overwriteUrl !== "") {
				url = url.replace("/secondPreview/", "/full/").replace("/preview/", "/full/");
				url = url.replace(/https:\/\/(.*?)\/item\/images/, "https://" + this.overwriteUrl);
			}

			if (Object.keys(this.imageOptions).length >= 2) {
				assetParams =
					"?scale.width=" +
					this.imageOptions.sizes[type] +
					"&scale.height=" +
					this.imageOptions.sizes[type] +
					(this.imageOptions.webp ? "" : "&format=original") +
					this.imageOptions.params;
			}

			return url + assetParams;
		},

		mountInit() {
			vueEventHub.$on("mz-ready", () => {
				MagicZoom.switchTo(this.$refs.single.id, 0);
			});

			vueEventHub.$on("mz-expand-open", () => {
				this.expandOpened = true;
			});

			vueEventHub.$on("mz-expand-close", () => {
				this.expandOpened = false;
			});

			vueEventHub.$on("mz-update", (payload) => {
				const prevIndex = parseInt(payload.prev_selector.getAttribute("data-index")) ?? -1;
				const newIndex = parseInt(payload.new_selector.getAttribute("data-index")) ?? -1;
				const lastIndex = this.carouselImages.length - 1;
				const direction = getDirection(prevIndex, newIndex, lastIndex);
				const nextIndex = this.getNextIndex(direction);
				const nextIndexIsVideo = this.videoCount > 0 && nextIndex >= 1 && nextIndex <= this.videoCount;

				if (this.isClickEvent) {
					this.isClickEvent = false;
					handleDefaultMzUpdate(newIndex);
				} else {
					if (this.suppressUpdate > 0) {
						this.suppressUpdate--;
					} else {
						this.currentItem = newIndex;

						if (!this.expandOpened && this.videoCount > 0 && prevIndex !== -1 && newIndex !== -1) {
							if (nextIndexIsVideo && !this.isVideoSlide) {
								this.isVideoSlide = true;
								this.currentItem = nextIndex;
								this.goTo(nextIndex, "video-1", false);

								this.suppressUpdate++;
								this.skipDirection = getDirection(prevIndex, newIndex, lastIndex, true);
								MagicZoom[this.skipDirection]("single-carousel-new");
							} else {
								if (this.isVideoSlide) {
									this.isVideoSlide = false;
								}
	
								handleDefaultMzUpdate(newIndex);
							}
						} else {
							handleDefaultMzUpdate(newIndex);
						}
					}
				}
			});

			this.$nextTick(() => {
				this.reInitialize();
			});
		},

		mzGoTo(direction) {
			const nextIndex = this.getNextIndex(direction);
			const isPrevDirection = direction === "prev";
			const isZoomActive = this.activeSlide === "zoom";
			const isOnFirstSlide = this.currentItem === 0;
			const isOnLastVideoSlide = this.currentItem === this.videoCount + 1;
			const hasMoreVideos = this.videoCount > this.currentItem;

			let nextSlide = "zoom";
			this.isClickEvent = true;

			if (isPrevDirection && isZoomActive && isOnLastVideoSlide) {
				nextSlide = "video-" + this.videoCount;
				this.skipDirection = "next";
			} else if (isPrevDirection && !isZoomActive && this.currentItem > 1) {
				nextSlide = "video-" + (this.currentItem + 1);
			} else if (!isPrevDirection && isZoomActive && isOnFirstSlide && this.videoCount > 0) {
				nextSlide = "video-1";
				this.skipDirection = "prev";
			} else if (!isPrevDirection && !isZoomActive && hasMoreVideos) {
				nextSlide = "video-" + (this.currentItem + 1);
			} else if (!isZoomActive && direction === this.skipDirection) {
				// hide the zoom slide while refreshing for slides other than the first to not confuse the viewer
				this.showCurtain = nextIndex > 1;
				// refresh when coming from video slide to zoom slide, because the MagicZoom Plugin freezes
				MagicZoom.refresh("single-carousel-new");

				// switch to desired image programmatically, since the refresh sets it to the first image
				if (nextIndex > 1) {
					MagicZoom.switchTo("single-carousel-new", (nextIndex - 1));
					setTimeout(() => {
						this.showCurtain = false;
					}, 700);
				}

				this.skipDirection = "none";
			} else {
				MagicZoom[direction]("single-carousel-new");
			}

			this.isVideoSlide = nextSlide !== "zoom";

			if (!isZoomActive && nextSlide === "zoom") {
				setTimeout(() => {
					this.goTo(nextIndex, nextSlide);
				}, 200);
			} else {
				this.goTo(nextIndex, nextSlide);
			}
		},

		getNextIndex(direction = "next") {
			const maxIndex = Math.max(0, this.carouselImages.length - 1);

			if (direction === "next") {
				return this.currentItem === maxIndex ? 0 : this.currentItem + 1;
			} else if (direction === "prev") {
				return this.currentItem - 1 < 0 ? maxIndex : this.currentItem - 1;
			} else {
				return this.currentItem;
			}
		}
	}
};
</script>
